import { createFileRoute, Link, Outlet, redirect, useRouterState } from '@tanstack/react-router';
import clsx from 'clsx';

const SUBTABS = [
  { to: '/admin/analytics/sessions', label: 'Sessions' },
  { to: '/admin/analytics/timeline', label: 'Timeline' },
  { to: '/admin/analytics/pulse', label: 'Pulse' },
] as const;

function AnalyticsBehaviorLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-semibold tracking-tight">Behavior</h1>
        <p className="mt-1 text-sm text-nova-muted-foreground">
          Visual sessions, day timelines, and a live pulse of what learners are doing.
        </p>
      </div>

      <nav className="flex gap-1 rounded-lg border border-nova-border bg-nova-muted/80 p-1">
        {SUBTABS.map((tab) => {
          const active = pathname.startsWith(tab.to);
          return (
            <Link
              key={tab.to}
              to={tab.to}
              className={clsx(
                'rounded-lg px-4 py-2 text-sm font-medium transition-colors',
                active
                  ? 'bg-nova-card text-nova-foreground shadow-sm'
                  : 'text-nova-muted-foreground hover:text-nova-foreground'
              )}
            >
              {tab.label}
            </Link>
          );
        })}
      </nav>

      <Outlet />
    </div>
  );
}

export const Route = createFileRoute('/admin/analytics')({
  beforeLoad: ({ location }) => {
    const path = location.pathname.replace(/\/$/, '');
    if (path === '/admin/analytics') {
      throw redirect({
        to: '/admin/analytics/sessions',
        search: { range: '7d', installation_id: '' },
      });
    }
  },
  component: AnalyticsBehaviorLayout,
});
